import Skeleton from '@material-ui/lab/Skeleton'

import classes from './styles/cryptoPaymentDeposit.module.scss'

export const CryptoPaymentDepositSkeleton = ({ isXRPCryptoType }) => {
  return (
    <>
      <div className={classes.cryptoPaymentDeposit__section}>
        <Skeleton
          className={classes.cryptoPaymentDeposit__skeleton}
          animation="wave"
          variant="rect"
          width={240}
          height={16}
          style={{ marginBottom: 6, marginLeft: 0 }}
        />
        <Skeleton
          className={classes.cryptoPaymentDeposit__skeleton}
          animation="wave"
          variant="rect"
          width="auto"
          height={40}
          style={{ marginBottom: 16 }}
        />
        <Skeleton
          className={classes.cryptoPaymentDeposit__skeleton}
          animation="wave"
          variant="rect"
          width={120}
          height={16}
          style={{ marginBottom: 6, marginLeft: 0 }}
        />
        <Skeleton
          className={classes.cryptoPaymentDeposit__skeleton}
          animation="wave"
          variant="rect"
          width="auto"
          height={40}
          style={{ marginBottom: 16 }}
        />
        {isXRPCryptoType && (
          <>
            <Skeleton
              className={classes.cryptoPaymentDeposit__skeleton}
              animation="wave"
              variant="rect"
              width={140}
              height={16}
              style={{ marginBottom: 6, marginLeft: 0 }}
            />
            <Skeleton
              className={classes.cryptoPaymentDeposit__skeleton}
              animation="wave"
              variant="rect"
              width="auto"
              height={40}
              style={{ marginBottom: 16 }}
            />
          </>
        )}
        <Skeleton
          className={classes.cryptoPaymentDeposit__skeleton}
          animation="wave"
          variant="rect"
          width={160}
          height={160}
          style={{ marginBottom: 8 }}
        />
        <Skeleton
          className={classes.cryptoPaymentDeposit__skeleton}
          animation="wave"
          variant="rect"
          height={14}
          width={180}
        />
      </div>
    </>
  )
}
